import { render, staticRenderFns } from "./EventReportTable.vue?vue&type=template&id=15d41b48&scoped=true"
import script from "./EventReportTable.vue?vue&type=script&lang=ts"
export * from "./EventReportTable.vue?vue&type=script&lang=ts"
import style0 from "./EventReportTable.vue?vue&type=style&index=0&id=15d41b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d41b48",
  null
  
)

export default component.exports